<template>
  <div>
  	<div>
      <el-select v-model="selectValue" :size="selectSize" placeholder="点击以筛选" style="float:left;margin-left:1%">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <div style="float: left;margin-left: 2%;text-align: center;line-height: 35px;font-size: 16px">标题/内容:</div>
      <el-input placeholder="输入水表编号用以检索"  v-model="counterCode" prefix-icon="el-icon-search" style="width:180px;float:left;margin-left:1%" autofocus="first_input" clearable>
      </el-input>
      <el-button type="primary" icon="icon-search" class="iconfont icon-search" style="float:left;margin-left:2%" @click="searchData">搜索</el-button>
  	</div>
  	<div>
	  <div class="infinite-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="5" infinite-scroll-delay="2000" style="float:center;height:500px;width:100%;overflow:auto">
	  	<div v-for="item in countData" :key="item">
	      <div class="except-div except-div2" v-if="item.state === 1">
	      	<div class="except-title">异常: 
            <b class="except-b" v-if="item.type === 0">漏抄表</b>
            <b class="except-b" v-if="item.type === 1">无数据</b>
            <b class="except-b" v-if="item.type === 2">行码较之前小</b>
          </div>
		      <div class="except-counter">表号:{{item.counterCode}}</div>
		      <div class="except-time">异常时间：{{item.copyTime}}</div>
          <div class="except-time">处理结果：{{item.remarks}}</div>
          <div class="except-button card-un" v-if="item.state == 1" @click="checkData(item.num, item.counts)">查看</div>
	      </div>
	      <div class="except-div except-div3" v-if="item.state === 0">
	      	<div class="except-title">异常: 
            <b class="except-b" v-if="item.type === 0">漏抄表</b>
            <b class="except-b" v-if="item.type === 1">无数据</b>
            <b class="except-b" v-if="item.type === 2">行码较之前小</b>
          </div>
		      <div class="except-counter">表号:{{item.counterCode}}</div>
		      <div class="except-time">异常时间：{{item.copyTime}}</div>
          <div class="except-button card-on" v-if="item.state == 0" @click="checkData(item.num, item.counts)">处理</div>
	       </div>
      </div>
	  </div>
    <el-dialog title="漏抄表处理记录" :visible.sync="dialogFormVisible" :modal-append-to-body="false" :show-close="true" width="200px" :close-on-click-modal="false">
      <el-form :model="form2">
        <el-form-item label="表号" :label-width="formLabelWidth">
          <div style="float:left">{{form2.counterCode}}</div>
        </el-form-item>
        <el-form-item label="缺失抄表日期" :label-width="formLabelWidth">
          <div style="float:left">{{form2.copyTime}}</div>
        </el-form-item>
        <el-form-item v-if="form2.type === 0" label="应抄次数" :label-width="formLabelWidth">
          <div style="float:left">{{form2.planTimes}}</div>
        </el-form-item>
        <el-form-item v-if="form2.type === 0" label="实抄次数" :label-width="formLabelWidth">
          <div style="float:left">{{form2.actualTimes}}</div>
        </el-form-item>
        <el-form-item v-if="form2.type !== 0" label="异常抄表图片" :label-width="formLabelWidth">
          <div style="float:left">
            <img style="height: 80px" :src="form2.imageUrl" />
          </div>
        </el-form-item>
        <el-form-item label="处理结果" :label-width="formLabelWidth">
          <el-input type="textarea" autosize v-model="form2.remarks" placeholder="请填入您的处理结果" v-if="form2.state == 0" auto-complete="off" style="width:410px;"></el-input>
          <div v-if="form2.state != 0">{{form2.remarks}}</div>
        </el-form-item>
        <el-form-item label="处理时间" :label-width="formLabelWidth" v-if="form2.state == 1">
          <div style="float:left">{{form2.updateTime}}</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="toUpdateState(form2.counts)">提 交</el-button>
      </div>
    </el-dialog>
  	</div>
  </div>
</template>
<script>
import { expire } from '@/utils/auth'
import { fetch } from '@/utils/api'
import { formateDate2, formateDate } from '@/utils/common'
export default {
  data () {
    return {
      countData: [],
      tmpData: {},
      page: 0,
      pageSize: 10,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      selectValue: 0,
      form2: {},
      options: [{
        value: 0,
        label: '未处理'
      }, {
        value: 1,
        label: '已处理'
      }, {
        value: -1,
        label: '全部'
      }],
      selectSize: 10,
      counterCode: '',
      theLastTime: '1970-01-01 00:00',
      theEndTime: '',
      init: true
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  created () {
    let times = (new Date()).getTime()
    this.theEndTime = formateDate(times)
  },
  methods: {
    loadMore () {
      if (!this.init) return
      // 访问后台拿列表数据
      fetch({
        url: '/except/copyData/base',
        params: {
          orderBy: 1,
          pageIndex: this.page,
          pageSize: this.pageSize,
          filterBy: this.counterCode,
          state: this.selectValue,
          theLastTime: this.theLastTime,
          theEndTime: this.theEndTime
        }
      }).then(data => {
        for (let i = 0; i < data.length; i++) {
          this.tmpData = {}
          this.tmpData.nums = data[i].id
          this.tmpData.counterCode = data[i].counterCode
          this.tmpData.copyTime = formateDate2(data[i].copyTime)
          this.tmpData.remarks = data[i].remark
          this.tmpData.state = data[i].state
          this.tmpData.type = data[i].type
          this.tmpData.planTimes = data[i].planTimes        // 应抄次数
          this.tmpData.actualTimes = data[i].actualTimes    // 实抄次数
          this.tmpData.imageUrl = data[i].imageUrl          // 异常抄表图片
          if (this.tmpData.state === 1) {
            this.tmpData.updateTime = data[i].updateTime
          }
          this.tmpData.counts = this.countData.length
          this.countData.push(this.tmpData)
        }
        this.page++
        if (data.length < this.pageSize) {
          this.init = false
        }
      })
    },
    searchData () {
      this.init = true
      this.page = 0
      this.countData = []
      this.loadMore()
    },
    handleChange (val) {
      console.log(val)
    },
    checkData (nums, counts) {
      this.dialogFormVisible = true
      this.form2 = this.countData[counts]
    },
    toUpdateState (counts) {
      // 提交
      if (this.form2.remarks.length === 0) {
        return
      }
      fetch({
        url: '/except/copyData/updateState',
        params: {
          id: this.form2.nums,
          remark: this.form2.remarks
        }
      }).then(data => {
        if (data.data === 1) {
          this.dialogFormVisible = false
          this.form2 = {}
          this.countData[counts].state = 1
          this.countData[counts].updateTime = '刚刚'
        }
      })
    }
  }
}
</script>
<style scoped lang="sass">
.except-div
 position: relative
 margin-top: 14px
 margin-left: 2%
 margin-right: 2%
 float: center
 overflow: auto
 background-color: #67c23a87
 border-radius: 10px
 border: 2px solid
 border-color: #67c23a6b
 height: 40px
 overflow-y: hidden
.except-div2
 border-color: #67c23a52
 background-color: #67c23a45
.except-div3
 border-color: #e8be4382
 background-color: #eabe3f61
.except-div .except-title
 width: 130px
 float: left
 line-height: 40px
 margin-left: 20px
 color: #525050
.except-div .except-counter
 float: left
 line-height: 40px
 margin-left: 2%
 color: #525050
.except-div .except-time
 float: left
 line-height: 40px
 color: #525050
 margin-left: 2%
.except-div .except-button
 font-size: 11px
 float: right
 padding: 3px 0
 border: 1px solid
 border-radius: 100%
 text-align: center
 top: 4px
 right: 4px
 position: absolute
.card-on
 border-color: #a3af6538 !important
 background-color: #11ad2bbf
 color: white
.card-un
 border-color: #a3af6538 !important
 background-color: #11ad2bbf
 color: white
</style>


// WEBPACK FOOTER //
// copyData.vue?0b6af677